import React from 'react'
import { useIntl } from 'react-intl'

import {
  Icon60CheckCircle2,
  Icon60FirewallBlock,
  IconFATimes,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  SkeletonLoader,
  SKELETON_LOADER_VARIANT_ONWHITE,
  Flex,
  FlexItem,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  Title,
  TITLE_VARIANT_M,
  Spinner
} from 'mailup-web-components'
import {
  IconWrapper,
  StyledPanel,
  StyledSpinner,
  StyledText
} from '../commonComponents/commonComponents'

import { useRecoilValue, useSetRecoilState } from 'recoil'
import {
  linkcheckSummaryBoxState,
  messageState
} from 'Pages/MessageCheckupLinkCheck/recoil/state/message'

const CheckReputation = () => {
  const intl = useIntl()
  const { showJustBadReputation, showJustUnreachable } = useRecoilValue(
    messageState
  )
  const setMessageState = useSetRecoilState(messageState)
  const {
    areAllLinksGoodReputation: areAllLinksGood,
    areAllLinksLoaded,
    goodReputationLinks: correctLinks,
    badReputationLinks: badLinks,
    linksDangerAction
  } = useRecoilValue(linkcheckSummaryBoxState)

  return (
    <StyledPanel filtered={showJustBadReputation}>
      <Flex columnGap='16px' alignItems='flex-start'>
        <FlexItem>
          <IconWrapper
            color={
              areAllLinksLoaded()
                ? areAllLinksGood()
                  ? 'var(--sushi)'
                  : linksDangerAction.length === 0
                  ? 'var(--sun)'
                  : 'var(--sunset-orange)'
                : undefined
            }
          >
            {areAllLinksGood() ? (
              <Icon60CheckCircle2 />
            ) : (
              <Icon60FirewallBlock />
            )}
          </IconWrapper>
        </FlexItem>

        <FlexItem width='100%'>
          <Flex
            height='36px'
            alignItems='flex-end'
            columnGap='16px'
            margin={!areAllLinksLoaded() ? '0 0 4px 0' : ''}
          >
            {areAllLinksLoaded() ? (
              <StyledText variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                {areAllLinksGood() ? correctLinks.length : badLinks.length}
              </StyledText>
            ) : (
              <StyledSpinner />
            )}
            <Title variant={TITLE_VARIANT_M} htmlElement='span'>
              {!areAllLinksLoaded() &&
                intl.formatMessage({
                  id: 'Load.EmailCheckUp.LinkCheckReputationLoading'
                })}
              {areAllLinksLoaded()
                ? areAllLinksGood()
                  ? intl.formatMessage({
                      id: 'Load.EmailCheckUp.LinkCheckGoodReputationTitleNew'
                    })
                  : intl.formatMessage({
                      id: 'Load.EmailCheckUp.LinkCheckBadReputationTitleNew'
                    })
                : null}
            </Title>
            {areAllLinksLoaded() && !areAllLinksGood() && (
              <>
                <Link
                  variant={LINK_VARIANT_HIGHLIGHT}
                  onClick={() => {
                    if (!showJustUnreachable && !showJustBadReputation) {
                      setMessageState(prev => ({
                        ...prev,
                        showJustBadReputation: !prev.showJustBadReputation
                      }))
                    } else {
                      setMessageState(prev => ({
                        ...prev,
                        showJustBadReputation: false
                      }))
                    }
                  }}
                >
                  {intl.formatMessage({ id: 'Load.MailupCommon.Show' })}
                  {showJustBadReputation && (
                    <IconWrapper color='inherit' fontSize='14px'>
                      {' '}
                      <IconFATimes />
                    </IconWrapper>
                  )}
                </Link>
              </>
            )}
          </Flex>

          {areAllLinksLoaded() ? (
            <>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {areAllLinksGood()
                  ? intl.formatMessage({
                      id:
                        'Load.EmailCheckUp.LinkCheckGoodReputationDescriptionNew'
                    })
                  : intl.formatMessage({
                      id:
                        'Load.EmailCheckUp.LinkCheckBadReputationDescriptionNew'
                    })}
              </Text>
            </>
          ) : (
            <SkeletonLoader
              variant={SKELETON_LOADER_VARIANT_ONWHITE}
              height='13px'
              width='80%'
            />
          )}
        </FlexItem>
      </Flex>
    </StyledPanel>
  )
}

export default CheckReputation
